/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Pillar_H2Inputs */

const es_cap_pillar_h2 = /** @type {(inputs: Cap_Pillar_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El timón es tuyo. En el barco y en tu trabajo.`)
};

const gl_cap_pillar_h2 = /** @type {(inputs: Cap_Pillar_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O timón é teu. No barco e no teu traballo.`)
};

const en_cap_pillar_h2 = /** @type {(inputs: Cap_Pillar_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You hold the helm. On the boat and in your work.`)
};

/**
* | output |
* | --- |
* | "You hold the helm. On the boat and in your work." |
*
* @param {Cap_Pillar_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_pillar_h2 = /** @type {((inputs?: Cap_Pillar_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Pillar_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_pillar_h2(inputs)
	if (locale === "en") return en_cap_pillar_h2(inputs)
	return es_cap_pillar_h2(inputs)
});